"use client";

import React, { useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Instagram, Twitter, Globe, Facebook } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const socialLinks = [{
  name: "Instagram",
  url: "https://www.instagram.com/birthingjoy_withjoss/",
  icon: Instagram
}, {
  name: "Facebook",
  url: "https://www.facebook.com/profile.php?id=100067390804899",
  icon: Facebook
}, {
  name: "Website",
  url: "/",
  icon: Globe
}];
export default function FreeConsultationRequest() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.14/iframeResizer.min.js";
    script.async = true;
    script.onload = () => {
      if (window.iFrameResize) {
        setTimeout(() => {
          window.iFrameResize({
            log: false,
            checkOrigin: false,
            heightCalculationMethod: 'taggedElement'
          }, '#dubsado-scheduler');
        }, 30);
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <section id="start-your-joyful-journey" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          
          <div ref={leftRef} className={`lg:col-span-4 space-y-10 transition-all duration-1000 ease-out ${isLeftVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-foreground leading-tight">
                Begin Your <br />
                <span className="italic font-serif font-light text-secondary">Joyful Journey</span>
              </h2>
              <Separator className="w-12 bg-ring/50 h-1" />
              <p className="text-lg text-foreground/80 leading-relaxed font-default">
                Whether you're seeking birth support, postpartum care, or lactation guidance, I'm here to walk alongside you during this sacred transition. Let's connect and see how I can support your family.
              </p>
            </div>

            <div className="space-y-6 pt-4">
              <h3 className="text-xl font-default font-semibold text-foreground">Reach Out</h3>
              <div className="flex flex-col space-y-4">
                {socialLinks.map((social, i) => <Link key={social.name} to={social.url} newTab className="group flex items-center space-x-4 text-foreground/70 hover:text-ring transition-colors duration-300 w-fit" data-index={i}>
                    <div className="size-10 rounded-full border border-border/50 bg-card flex items-center justify-center group-hover:border-ring/50 group-hover:bg-ring/10 transition-all duration-300 shadow-sm">
                      <social.icon className="size-4" />
                    </div>
                    <span className="font-default font-medium">{social.name}</span>
                  </Link>)}
              </div>
            </div>

            <div className="pt-8">
              <p className="text-sm text-foreground/60 font-default">
                Serving West Palm Beach & surrounding areas.<br />
                Virtual support available worldwide.
              </p>
            </div>
          </div>

          <div ref={rightRef} className={`lg:col-span-8 transition-all duration-1000 delay-200 ease-out ${isRightVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <Card className="bg-card/80 backdrop-blur-sm border-border/30 shadow-xl rounded-lg overflow-hidden relative">
              <div className="absolute -top-40 -right-40 size-80 bg-ring/5 rounded-full blur-[100px] pointer-events-none" />
              <div className="absolute -bottom-40 -left-40 size-80 bg-chart-2/5 rounded-full blur-[100px] pointer-events-none" />
              
              <CardHeader className="pb-8 relative z-10">
                <CardTitle className="leading-none font-semibold text-foreground !font-serif !text-3xl">Book Your Free Consultation</CardTitle>
                <CardDescription className="text-base font-default">
                  Schedule a free 30-minute consultation with our team to discuss your project.
                </CardDescription>
              </CardHeader>
              <CardContent className="relative z-10">
                <div className="w-full h-auto min-h-[600px]">
                  <iframe id="dubsado-scheduler" title="Book Your Free Consultation" src="https://hello.dubsado.com:443/public/appointment-scheduler/662a79049b3568003af78fe0/schedule?isIframe=true" className="w-full border-none" style={{
                  width: '1px',
                  minWidth: '100%'
                }} frameBorder="0" scrolling="no" allowFullScreen />
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}